import {Schema} from './schema.js';
import {TypeReference} from './types.js';


export interface IPlugin {
  setup(schema: Schema): void;

  registerPrototypes(): APIRegistry;

  registerStatics(): APIRegistry;
}
export type APIRegistry = Map<TypeReference, API>;
export type API = { [k: string]: APIFunction };
export type APIFunction = (...args: any[]) => APIResult;
export class APIResult {
  constructor(public outputType: TypeReference, public  outputValue: any) {
  }

  static boolean(value: boolean) {
    return new APIResult(Schema.boolean_type.getTypeReference(), value);
  }

  static string(value: string) {
    return new APIResult(Schema.string_type.getTypeReference(), value);
  }

  static mlString(value: string) {
    return new APIResult(Schema.ml_string_type.getTypeReference(), value);
  }

  static number(value: number) {
    return new APIResult(Schema.number_type.getTypeReference(), value);
  }

  static custom(outputType: TypeReference, value: any) {
    return new APIResult(outputType, value);
  }
}

export class PluginBase implements IPlugin {
  registerPrototypes(): APIRegistry {
    return new Map<TypeReference, API>();
  }

  registerStatics(): APIRegistry {
    return new Map<TypeReference, API>()
  }

  setup(schema: Schema): void {
  }
}
